/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, names: NonNullable<unknown> }} Wrapped_Period_Map_LabelInputs */

const en_us2_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Map of the muscles worked in ${i?.range}: ${i?.names}`)
};

const pt_br2_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa dos músculos trabalhados em ${i?.range}: ${i?.names}`)
};

const es_419_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa de los músculos trabajados en ${i?.range}: ${i?.names}`)
};

const pt_pt2_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa dos músculos trabalhados em ${i?.range}: ${i?.names}`)
};

const fr_fr2_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carte des muscles travaillés en ${i?.range} : ${i?.names}`)
};

const de_de2_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Karte der trainierten Muskeln in ${i?.range}: ${i?.names}`)
};

const it_it2_wrapped_period_map_label = /** @type {(inputs: Wrapped_Period_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mappa dei muscoli allenati in ${i?.range}: ${i?.names}`)
};

/**
* | output |
* | --- |
* | "Map of the muscles worked in {range}: {names}" |
*
* @param {Wrapped_Period_Map_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_map_label = /** @type {((inputs: Wrapped_Period_Map_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Map_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_map_label(inputs)
	if (locale === "es-419") return es_419_wrapped_period_map_label(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_map_label(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_map_label(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_map_label(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_map_label(inputs)
	return en_us2_wrapped_period_map_label(inputs)
});
export { wrapped_period_map_label as "wrapped-period.map_label" }